export default Object.freeze({
    // Environment file
    IPO_START_DATE_FORMAT: 'YYYY-MM-DD',

    // Api
    API_REQUEST_DATE_FORMAT: 'YYYY-MM-DD',
    API_RESPONSE_DATE_FORMAT: 'YYYY-MM-DD',
    API_RESPONSE_DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss[Z]',

    // UI
    UI_TIME_ZONE: 'Europe/Copenhagen',
    UI_DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    UI_DEFAULT_DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
    UI_DATE_PICKER_DATE_FORMAT: 'yyyy-MM-dd',

    // Moment compare format (In code)
    UI_MOMENT_COMPARE_DATE_FORMAT: 'YYYY-MM-DD'
});
